import styled from '@emotion/styled';

import breakpoints from 'app/styles/constants/breakpoints';
import { endDirection, startDirection } from 'app/styles/selectors/markup';

const { widthMedium } = breakpoints;
const S = {};

S.BackgroundImage = styled.div`
  label: BackgroundImage;

  ${({ theme }) =>
    theme.markup.dir === 'rtl' ? 'transform: scaleX(-1)' : 'transform: none'};
  top: 0;
  position: absolute;
  ${endDirection}: 0;
  display: none;
  z-index: var(--z-index-under-background);
  margin-${startDirection}: 20rem;

  @media (${widthMedium}) {
    display: block;
  }
`;

S.BackgroundImage.Image = styled.img`
  label: Image;

  width: 100%;
`;

export default S;
